/**
 * WebSocket Configuration Constants
 * Centralized constants for Verify UI WebSocket functionality
 */

// WebSocket Connection Settings
export const WEBSOCKET_CONNECTION = {
  // Connection timeout in milliseconds
  CONNECTION_TIMEOUT_MS: 5000,

  // Reconnection settings
  MAX_RECONNECT_ATTEMPTS: 5,
  RECONNECT_DELAY_MS: 3000,

  // Keep-alive settings
  PING_INTERVAL_MS: 30000, // 30 seconds
} as const;

// Video Capture Settings
export const VIDEO_CAPTURE = {
  // Frame rate settings
  FRAME_RATE_FPS: 5,
  FRAME_RATE_MS: 200, // 5 FPS = 200ms intervals

  // Video quality settings - balanced for face quality without oversized WS payloads
  IMAGE_QUALITY: 0.86, // JPEG compression quality (0-1)

  // Video dimensions - MATCHED TO DOCUMENT CAPTURE RESOLUTION
  IDEAL_WIDTH: 1920,   // Increased from 640 to match document capture
  IDEAL_HEIGHT: 1080,  // Increased from 480 to match document capture

  // Mobile video dimensions - IMPROVED FOR QUALITY PARITY
  MOBILE_WIDTH: 1920,  // Increased from 280 to match document capture 
  MOBILE_HEIGHT: 1080, // Increased from 280 to match document capture
  DESKTOP_WIDTH: 1920, // Increased from 320 to match document capture
  DESKTOP_HEIGHT: 1080, // Increased from 320 to match document capture
} as const;

// Timing Constants
export const TIMING = {
  // Delays before starting operations
  CAMERA_READY_DELAY_MS: 1000,
  SUCCESS_CALLBACK_DELAY_MS: 500,
  SDK_SUCCESS_DELAY_MS: 100,

  // Zone transition timing
  ZONE_TRANSITION_DISPLAY_MS: 2000,
} as const;

// Age Verification Settings
export const AGE_VERIFICATION = {
  // Default challenge age
  DEFAULT_CHALLENGE_AGE: 25,

  // Age range limits
  MIN_AGE: 18,
  MAX_AGE: 100,
} as const;

// UI Constants
export const UI = {
  // Mobile breakpoint
  MOBILE_BREAKPOINT_PX: 480,

  // Text sizes
  DEFAULT_FONT_SIZE_PX: 18,
  MOBILE_FONT_SIZE_PX: 16,

  // Spacing
  DEFAULT_MIN_HEIGHT_PX: 50,
  MOBILE_MIN_HEIGHT_PX: 45,
} as const;

// Export all constants as a single object for convenience
export const VERIFY_UI_CONSTANTS = {
  WEBSOCKET_CONNECTION,
  VIDEO_CAPTURE,
  TIMING,
  AGE_VERIFICATION,
  UI,
} as const;
